import produce from 'immer';

import {
    FUND_TRANSFER_SET_INTERNAL_BALANCE,
    FUND_TRANSFER_SET_EXTERNAL_BALANCE
} from './actions';

export const defaultState = {};

export const reducer = (reducerSuffix) => produce((draftState, action) => {
    switch (action.type) {
        case FUND_TRANSFER_SET_INTERNAL_BALANCE:
        case FUND_TRANSFER_SET_INTERNAL_BALANCE + reducerSuffix: {
            draftState.internalBalance = action.payload;

            break;
        }

        case FUND_TRANSFER_SET_EXTERNAL_BALANCE:
        case FUND_TRANSFER_SET_EXTERNAL_BALANCE + reducerSuffix: {
            draftState.externalBalance = action.payload;

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
